export default __webpack_public_path__ + "static/media/partner3.bce34d89.png";